export default {
  back: 'Back',
  language: 'Change language',
  connection: 'Connection status',
  connectionMessage: 'NASA API Connection: Under development'
}
